export function Settings() {
  return (
    <div>
      <h1 className="text-3xl font-bold">Settings</h1>
    </div>
  );
}

